import { DsDatePickerOverrides } from './Components';
const XDatePickerComponentOverrides = {
    ...DsDatePickerOverrides
};
export default XDatePickerComponentOverrides;
